import styled from 'styled-components';
import { Button, Col, Modal, Slider } from 'antd';
import { BOTTOM_MARGIN, ICON_SIZE } from './utils/constants';

const OVERLAY_LAYER_Z = 15;

function getVisibilityOpacity($visible?: boolean): number {
	return $visible ? 1 : 0;
}

function getVisibilityPointerEvents($visible?: boolean): string {
	return $visible ? 'auto' : 'none';
}

export const HoverIcon = styled.span`
	display: inline-flex;
	width: ${ICON_SIZE}px;
	height: ${ICON_SIZE}px;
	color: ${({ theme }) => theme.palette.secondary.white};
	transition: color 0.2s ease;

	svg {
		fill: currentColor;
		transition: fill 0.2s ease;
	}

	button:hover & {
		color: ${({ theme }) => theme.palette.secondary['200']};
	}
`;

export const VideoContainerWrapper = styled.div<{ $portrait?: boolean }>`
	width: 100%;
	aspect-ratio: ${({ $portrait }) => ($portrait ? '9 / 16' : '16 / 9')};
	max-width: ${({ $portrait }) => ($portrait ? '30rem' : '54rem')};
	position: relative;
	overflow: hidden;
	background: #000;
	border-radius: 1rem;
`;

export const CloseButton = styled.div`
	top: 1rem;
	right: 1rem;
	z-index: 10;
	cursor: pointer;
	position: absolute;
`;

export const VideoContainer = styled.div`
	width: 100%;
	height: 100%;
	display: flex;
	cursor: pointer;
	max-width: 54rem;
	position: relative;
	align-items: center;
	justify-content: center;

	> div {
		width: 100% !important;
		height: 100% !important;
		pointer-events: none;
		border-radius: 1rem;
	}

	video {
		border-radius: 1rem;
		object-fit: contain;
		pointer-events: none;
	}
`;

export const DraggableVideoModal = styled(Modal)`
	.ant-modal-wrap {
		padding: 0 !important;
		overflow: hidden !important;
	}

	.ant-modal {
		margin: 0 !important;
		padding: 0 !important;
		width: 20rem !important;
		height: 11.25rem !important;
		overflow: hidden !important;
		border-radius: 0.5rem;
		box-shadow: none !important;
	}

	.ant-modal-content {
		padding: 0 !important;
		margin: 0 !important;
		width: 20rem !important;
		height: 11.25rem !important;
		border-radius: 0.5rem;
		background: ${({ theme }) => theme.palette.secondary['500']};
		overflow: hidden !important;
		box-shadow: none !important;
	}

	.ant-modal-close {
		top: 1.2rem;
		margin-right: 1rem;
		inset-inline-end: 1rem;
		z-index: 10;
	}

	.ant-modal-body {
		width: 20rem !important;
		height: 11.25rem !important;
		display: flex;
		cursor: move;
		padding: 0 !important;
		margin: 0 !important;
		border: none !important;
		background: ${({ theme }) => theme.palette.secondary['500']} !important;
		position: relative;
		border-radius: 0.5rem;
		overflow: hidden !important;
		align-items: center;
		justify-content: center;

		> div {
			width: 100% !important;
			height: 100% !important;
			pointer-events: none;
			overflow: hidden !important;
		}

		video {
			width: 100% !important;
			height: 100% !important;
			border-radius: 0.5rem;
			object-fit: contain;
			pointer-events: none;
			box-shadow: 0.1169rem 0.2344rem 0.4688rem 0rem #0000003d;
		}
	}
`;

export const MinimizedPlayerContainer = styled.div`
	right: 0;
	bottom: ${BOTTOM_MARGIN}px;
	z-index: 1000;
	position: fixed;
`;

export const MinimizedPlayer = styled.div`
	gap: 0.5rem;
	width: 2rem;
	cursor: move;
	display: flex;
	height: 11.25rem;
	position: relative;
	padding-top: 0.5rem;
	padding-left: 0.25rem;
	padding-right: 0.25rem;
	padding-bottom: 0.5rem;
	flex-direction: column;
	border-top-left-radius: 0.5rem;
	border-bottom-left-radius: 0.5rem;
	background: ${({ theme }) => theme.palette.secondary['250']};
`;

export const MinimizedPlayerButton = styled.button`
	padding: 0;
	border: none;
	margin: auto;
	display: flex;
	cursor: pointer;
	align-items: center;
	justify-content: center;
	background: transparent;
	color: ${({ theme }) => theme.palette.secondary.white};
`;

export const ResizeButton = styled.button`
	padding: 0;
	border: none;
	display: flex;
	right: 0.25rem;
	bottom: 0.5rem;
	cursor: pointer;
	position: absolute;
	align-items: center;
	justify-content: center;
	background: transparent;
`;

export const ControlsBarWrapper = styled.div<{ $visible: boolean }>`
	left: 0;
	right: 0;
	display: flex;
	bottom: 0rem;
	align-items: end;
	position: absolute;
	padding: 0.5rem 1.5rem;
	transform: translateY(0);
	justify-content: flex-start;
	border-bottom-left-radius: 1rem;
	border-bottom-right-radius: 1rem;
	opacity: ${({ $visible }) => getVisibilityOpacity($visible)};
	pointer-events: ${({ $visible }) => getVisibilityPointerEvents($visible)};
	background: linear-gradient(180deg, rgba(38, 38, 38, 0) 89%, #262626 100%);
	box-shadow: ${({ $visible }) => ($visible ? '0 0.25rem 0.5rem rgba(0, 0, 0, 0.25)' : 'none')};
	z-index: 1000;
	transition:
		opacity 0.35s ease,
		transform 0.35s ease,
		box-shadow 0.35s ease;
`;

export const DraggableControlsBarWrapper = styled.div<{ $visible: boolean }>`
	left: 0;
	width: 100%;
	display: flex;
	bottom: 0rem;
	align-items: end;
	position: absolute;
	padding: 0.5rem 1.5rem;
	transform: translateY(0);
	justify-content: flex-start;
	border-bottom-left-radius: 0.5rem;
	border-bottom-right-radius: 0.5rem;
	color: ${({ theme }) => theme.palette.secondary.white};
	opacity: ${({ $visible }) => getVisibilityOpacity($visible)};
	pointer-events: ${({ $visible }) => getVisibilityPointerEvents($visible)};
	background: linear-gradient(180deg, rgba(38, 38, 38, 0) 78%, #262626 100%);
	box-shadow: ${({ $visible }) => ($visible ? '0 0.25rem 0.5rem rgba(0, 0, 0, 0.25)' : 'none')};
	z-index: 1000;
	transition:
		opacity 0.35s ease,
		transform 0.35s ease,
		box-shadow 0.35s ease;
`;

export const ControlsBar = styled.div`
	gap: 1rem;
	padding: 0;
	width: 100%;
	display: flex;
	align-items: center;
	flex: 1;
	color: ${({ theme }) => theme.palette.secondary.white};
	z-index: 1000;
`;

export const ControlItem = styled.div<{ $offsetTop?: boolean }>`
	display: flex;
	position: relative;
	align-items: center;
	pointer-events: auto;
	${({ $offsetTop }) => ($offsetTop ? 'margin-top: -4px;' : '')}
`;

export const TimeDisplay = styled.span`
	white-space: nowrap;
	font-size: ${({ theme }) => theme.sizes.fonts.fs_sm};
	color: ${({ theme }) => theme.palette.secondary.white};
	font-weight: ${({ theme }) => theme.sizes.weights.regular};
`;

export const SliderContainer = styled.div`
	flex: 1;
	min-width: 0;
	position: relative;
	pointer-events: auto;
`;

export const SliderHoverTooltip = styled.div<{ $left: number }>`
	position: absolute;
	bottom: 1.5rem;
	padding: 0.25rem 0.5rem;
	white-space: nowrap;
	pointer-events: none;
	transform: translateX(-50%);
	left: ${({ $left }) => $left}px;
	font-size: ${({ theme }) => theme.sizes.fonts.fs_xs};
	color: ${({ theme }) => theme.palette.secondary['500']};
	background: ${({ theme }) => theme.palette.secondary['150']};
	border-radius: ${({ theme }) => theme.border.border_radius.br_sm};

	&::after {
		content: '';
		position: absolute;
		top: 100%;
		left: 50%;
		transform: translateX(-50%);
		border-width: 0.25rem;
		border-style: solid;
		border-color: ${({ theme }) => theme.palette.secondary['150']} transparent transparent transparent;
	}
`;

export const TimeSliderWrapper = styled(Slider)`
	margin: 0;
	opacity: 1;
	border: none;
	width: 100%;
	height: 0.25rem;
	pointer-events: auto;
	background: ${({ theme }) => theme.palette.secondary['250']};
	border-radius: ${({ theme }) => theme.border.border_radius.br_lg};

	&.ant-slider-horizontal {
		padding-block: 0 !important;
		height: 0.25rem !important;
	}

	.ant-slider-rail {
		background: ${({ theme }) => theme.palette.secondary['250']};
		border-radius: ${({ theme }) => theme.border.border_radius.br_lg};
	}

	.ant-slider-track {
		border: none;
		border-radius: ${({ theme }) => theme.border.border_radius.br_lg};
		color: ${({ theme }) => theme.palette.secondary.white} !important;
		background: ${({ theme }) => theme.palette.secondary.white} !important;
		border-color: ${({ theme }) => theme.palette.secondary.white} !important;
	}

	.ant-slider-handle {
		top: -0.375rem !important;
		margin-top: 0 !important;
		width: 1rem !important;
		height: 1rem !important;
		border: none !important;
		box-shadow: none !important;
		border-radius: 50% !important;
		background-color: ${({ theme }) => theme.palette.secondary.white} !important;
	}

	.ant-slider-handle::before {
		display: none !important;
		content: none !important;
	}

	.ant-slider-handle::after {
		display: none !important;
		content: none !important;
	}

	.ant-slider-handle:focus {
		box-shadow: 0 0 0 0.3125rem rgba(255, 255, 255, 0.12) !important;
	}

	.ant-tooltip {
		z-index: 100001 !important;

		.ant-tooltip-inner {
			min-height: auto;
			padding: 0.25rem 0.5rem;
			font-size: ${({ theme }) => theme.sizes.fonts.fs_xs};
			background: ${({ theme }) => theme.palette.secondary['500']};
			border-radius: ${({ theme }) => theme.border.border_radius.br_sm};
		}

		.ant-tooltip-arrow::before {
			background: ${({ theme }) => theme.palette.secondary['500']};
		}
	}
`;

export const VolumeSliderWrapper = styled.div`
	bottom: 100%;
	position: absolute;
	pointer-events: auto;
	padding: 0.5rem;
	border-radius: ${({ theme }) => theme.border.border_radius.br_sm};
	background: ${({ theme }) => theme.palette.secondary.white};
	width: 2rem;
	display: flex;
	align-items: center;
	justify-content: center;
	box-shadow: 2px 2px 8px 0px ${({ theme }) => theme.palette.secondary['200']};

	.ant-tooltip {
		.ant-tooltip-inner {
			background: ${({ theme }) => theme.palette.primary['100']} !important;
			color: ${({ theme }) => theme.palette.secondary['500']} !important;
		}

		.ant-tooltip-arrow::before {
			background: ${({ theme }) => theme.palette.primary['100']} !important;
		}
	}
`;

export const VolumeSlider = styled(Slider)`
	margin: 0.5rem 0 0.5rem 0;
	height: 5rem;
	background: transparent;
	border-radius: ${({ theme }) => theme.border.border_radius.br_lg};

	.ant-slider-rail {
		left: 50% !important;
		width: 0.25rem !important;
		transform: translateX(-50%);
		background-color: ${({ theme }) => theme.palette.secondary['150']} !important;
		border-radius: ${({ theme }) => theme.border.border_radius.br_sm};
	}

	.ant-slider-track {
		left: 50% !important;
		width: 0.25rem !important;
		transform: translateX(-50%);
		border-radius: ${({ theme }) => theme.border.border_radius.br_sm};
		background: ${({ theme }) => theme.palette.primary['400']} !important;
	}

	.ant-slider-handle {
		width: 0.75rem;
		height: 0.75rem;
		box-shadow: none !important;
		border-radius: 50% !important;
		margin-left: -0.0625rem !important;
		background: ${({ theme }) => theme.palette.primary['400']} !important;
	}

	&& .ant-slider-handle.ant-slider-handle-dragging {
		border: 0.125rem solid ${({ theme }) => theme.palette.primary['400']} !important;
		margin-left: -0.0625rem !important;
		box-shadow: 0 0 0 0.1875rem ${({ theme }) => theme.palette.primary['200']} !important;
	}

	.ant-slider-handle::before,
	.ant-slider-handle::after {
		display: none !important;
		content: none !important;
	}

	.ant-slider-handle:focus {
		box-shadow: 0 0 0 0.25rem rgba(255, 255, 255, 0.2) !important;
	}

	.ant-slider-handle:hover {
		border-color: ${({ theme }) => theme.palette.secondary.white} !important;
	}
`;

export const VelocityDropdownWrapper = styled.div<{ $isDraggable?: boolean }>`
	right: 0;
	bottom: 100%;
	padding: 0.125rem 0;
	position: absolute;
	pointer-events: auto;
	background: ${({ theme }) => theme.palette.secondary.white};
	border-radius: ${({ theme }) => theme.border.border_radius.br_sm};
	box-shadow: 2px 2px 8px 0px ${({ theme }) => theme.palette.secondary['200']};

	&::after {
		content: '';
		position: absolute;
		bottom: -0.5rem;
		left: 0;
		right: 0;
		height: 0.5rem;
	}
`;

export const VelocityDropdownList = styled.div<{ $isDraggable?: boolean }>`
	display: flex;
	overflow-y: auto;
	max-height: ${({ $isDraggable }) => ($isDraggable ? '6rem' : '10rem')};
	flex-direction: column;

	scrollbar-width: none;
	-ms-overflow-style: none;

	&::-webkit-scrollbar {
		display: none;
	}
`;

export const CustomScrollbar = styled.div<{ $top: number }>`
	top: 0.5rem;
	right: 0.25rem;
	width: 0.25rem;
	height: 3rem;
	z-index: 1;
	cursor: grab;
	position: absolute;
	border-radius: 0.5rem;
	background: ${({ theme }) => theme.palette.secondary['250']};
	transform: translateY(${({ $top }) => $top}px);

	&:active {
		cursor: grabbing;
	}
`;

export const VelocityOption = styled.div<{ $active: boolean }>`
	cursor: pointer;
	padding: 0.5rem 1rem;
	font-size: ${({ theme }) => theme.sizes.fonts.fs_sm};
	border-bottom: 1px solid ${({ theme }) => theme.palette.secondary['100']};
	background-color: ${({ theme, $active }) => ($active ? theme.palette.primary['100'] : 'transparent')};
	color: ${({ theme, $active }) => ($active ? theme.palette.primary['500'] : theme.palette.secondary['500'])};
	font-weight: ${({ theme, $active }) => ($active ? theme.sizes.weights.semibold : theme.sizes.weights.regular)};
	min-width: 4rem;

	&:hover {
		background-color: ${({ theme }) => theme.palette.secondary['100']};
	}

	&:last-child {
		border-bottom: none;
	}
`;

interface LoadingContainerProps {
	$isDraggable?: boolean;
	$seeking?: boolean;
}

export const LoadingContainer = styled.div<LoadingContainerProps>`
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	z-index: 1;
	display: flex;
	position: absolute;
	border-radius: ${({ $isDraggable }) => ($isDraggable ? '0' : '1rem')};
	align-items: center;
	justify-content: center;
	background-color: ${({ $seeking, theme }) => ($seeking ? 'transparent' : theme.palette.secondary['150'])};
	z-index: -1;
`;

export const VideoThumbnailContainer = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	z-index: 10;
	height: 100%;
	width: 100%;
	display: flex;
`;

interface ColProps {
	$visible?: boolean;
}

export const MinimizeCol = styled(Col)<ColProps>`
	position: absolute;
	top: 0.3rem;
	left: 0rem;
	z-index: 10;
	opacity: ${({ $visible }) => getVisibilityOpacity($visible)};
`;

export const PlayCol = styled(Col)<ColProps>`
	top: 50%;
	left: 50%;
	z-index: 10;
	position: absolute;
	opacity: ${({ $visible }) => getVisibilityOpacity($visible)};
	transform: translate(-50%, -50%);
`;

const FULLSCREEN_FILL = `
	margin: 0 !important;
	padding: 0 !important;
	width: 100% !important;
	height: 100% !important;
	max-width: none !important;
	max-height: none !important;
	overflow: hidden !important;
`;

export const FullscreenContainer = styled.div`
	width: 100%;
	display: flex;
	justify-content: center;

	&:fullscreen {
		width: 100vw;
		height: 100vh;
		margin: 0;
		padding: 0;
		display: flex;
		overflow: hidden;
		align-items: stretch;
		justify-content: stretch;
		background: ${({ theme }) => theme.palette.secondary['500']};
	}

	&:fullscreen > * {
		flex: 1 1 auto;
		min-width: 0;
		min-height: 0;
		${FULLSCREEN_FILL}
	}

	&:fullscreen * {
		max-width: none !important;
		max-height: none !important;
	}

	&:fullscreen > * > *:last-child {
		align-items: stretch;
		justify-content: stretch;
		min-height: 100%;
	}

	&:fullscreen .ant-modal-wrap {
		inset: 0 !important;
		display: flex !important;
		position: fixed !important;
		align-items: stretch !important;
		justify-content: stretch !important;
		${FULLSCREEN_FILL}
	}

	&:fullscreen .ant-modal-centered::before {
		display: none !important;
	}

	&:fullscreen .ant-modal-centered .ant-modal {
		display: block !important;
	}

	&:fullscreen .react-draggable {
		transform: none !important;
		flex: 1 1 auto !important;
		min-height: 0 !important;
		${FULLSCREEN_FILL}
	}

	&:fullscreen .react-draggable > div {
		${FULLSCREEN_FILL}
	}

	&:fullscreen .ant-modal,
	&:fullscreen .ant-modal-content,
	&:fullscreen .ant-modal-body {
		top: 0 !important;
		border-radius: 0 !important;
		width: 100vw !important;
		height: 100vh !important;
		margin: 0 !important;
		padding: 0 !important;
		overflow: hidden !important;
	}

	&:fullscreen .ant-modal-body video {
		border-radius: 0 !important;
	}
`;

export const OverlayControlsLayer = styled.div<{ $show: boolean }>`
	inset: 0;
	width: 100%;
	height: 100%;
	position: absolute;
	z-index: ${OVERLAY_LAYER_Z};
	pointer-events: none;
	opacity: ${({ $show }) => ($show ? 1 : 0)};
	transition: opacity 0.25s ease;

	& > * {
		pointer-events: ${({ $show }) => ($show ? 'auto' : 'none')} !important;
	}
`;

export const PauseOverlay = styled.div<{ $visible: boolean }>`
	inset: 0;
	position: absolute;
	z-index: ${OVERLAY_LAYER_Z};
	opacity: ${({ $visible }) => ($visible ? 1 : 0)};
	transition: opacity 0.25s ease;
	background: rgba(0, 0, 0, 0.45);
	border-radius: inherit;
	cursor: ${({ $visible }) => ($visible ? 'pointer' : 'default')};
	pointer-events: ${({ $visible }) => ($visible ? 'auto' : 'none')} !important;
`;

export const CenterPlayWrapper = styled.div`
	top: 50%;
	left: 50%;
	z-index: ${OVERLAY_LAYER_Z + 1};
	position: absolute;
	transform: translate(-50%, -50%);
	pointer-events: auto !important;
`;

export const TopLeftActionWrapper = styled.div`
	top: 0.3rem;
	left: 0.5rem;
	z-index: ${OVERLAY_LAYER_Z + 1};
	position: absolute;
	pointer-events: auto !important;
`;

export const ControlButton = styled(Button)`
	border: none;
	background-color: transparent;
	color: ${({ theme }) => theme.colors.primary};

	&:hover,
	&:focus {
		background-color: transparent;
		color: ${({ theme }) => theme.colors.primary};
	}

	&:disabled,
	&:disabled:hover {
		border: none;
		background-color: transparent;
		color: ${({ theme }) => theme.palette.secondary['250']};
	}
`;
